export default __webpack_public_path__ + "static/StatementXinjiang2021-4863bb063895ade9cf62491fce2263c0.pdf";